export interface DeleteFromWishlistDetailsDto
{
    getId(): string;
    getStatus(): string;
}

export class DeleteFromWishlistDetailsDtoImpl implements DeleteFromWishlistDetailsDto
{
    private id: string;
    private status: string;

    getId(): string 
    {
        return this.id;
    }
    setId(id: string)
    {
        this.id = id;
    }

    getStatus(): string 
    {
        return this.status;
    }
    setStatus(status: string)
    {
        this.status = status;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/wishlist/deletefromwishlist/deletefromwishlistdetailsdto.tsx